/**
 * confirmDialog.js — promise-based replacement for window.confirm, built on
 * core/modal.js. Focus lands on the SAFE action (Cancel); Escape, scrim click,
 * and the close button all resolve false. `danger: true` styles the confirm
 * button destructively.
 *
 *   if (await confirmDialog({ title: 'Remove this passkey?', danger: true,
 *                             confirmLabel: 'Remove' })) { ... }
 */

import { openModal } from './modal.js';

const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ESC[c]);

export function confirmDialog({
  title = 'Are you sure?',
  message = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
} = {}) {
  return new Promise((resolve) => {
    let decided = false;
    const decide = (v) => { if (!decided) { decided = true; resolve(v); } };

    const content = document.createElement('div');
    content.innerHTML = `
      ${message ? `<p style="margin:0 0 4px">${esc(message)}</p>` : ''}
      <div class="m5t-modal__foot" style="margin:16px -20px -18px; padding-left:20px; padding-right:20px">
        <button type="button" class="m5t-modal__btn" data-x="cancel">${esc(cancelLabel)}</button>
        <button type="button" class="m5t-modal__btn ${danger ? 'm5t-modal__btn--danger' : 'm5t-modal__btn--primary'}" data-x="confirm">${esc(confirmLabel)}</button>
      </div>`;

    const { close } = openModal({
      label: title,
      content,
      onClose: () => decide(false), // Escape / scrim / close button = safe answer
    });

    content.querySelector('[data-x="cancel"]').addEventListener('click', () => { decide(false); close(); });
    content.querySelector('[data-x="confirm"]').addEventListener('click', () => { decide(true); close(); });
    // Safe action holds initial focus.
    requestAnimationFrame(() => content.querySelector('[data-x="cancel"]')?.focus());
  });
}
